function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h113.4v14.1H0zM0 35h113.4v14.1H0z"
});

var Svg2 = function Svg2(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 113.4 49.1"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMTMuNCA0OS4xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMTMuNCA0OS4xOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHdpZHRoPSIxMTMuNCIgaGVpZ2h0PSIxNC4xIi8+CjxyZWN0IHk9IjM1IiB3aWR0aD0iMTEzLjQiIGhlaWdodD0iMTQuMSIvPgo8L3N2Zz4K";
export { Svg2 as ReactComponent };